import { TOrganizationData } from "@/frontend/pages/ExpertRootPage/model/types/types";
import $api from "@/frontend/shared/api/axios";

export const getOrganizations: () => Promise<TOrganizationData[]> = async () => {
  const response = await $api.get("/experts/organizations");
  return response.data.data;
};
